import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=c92c5988"
import script from "./loader.vue?vue&type=script&lang=js"
export * from "./loader.vue?vue&type=script&lang=js"
import style0 from "./loader.vue?vue&type=style&index=0&id=c92c5988&prod&lang=scss"
import style1 from "./loader.vue?vue&type=style&index=1&id=c92c5988&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports